<template>
    <div class="px-6 surface-overlay relative">

        <ul class="list-none p-3 m-0 surface-card flex align-items-center font-medium overflow-x-auto">
            <li class="pr-3">
                <a @click="processRegister" class="cursor-pointer">
                    <i class="pi pi-home text-teal-500"></i>
                </a>
            </li>
            <li class="px-1">
                <i class="pi pi-angle-right text-500"></i>
            </li>
            <li class="px-1">
                <a @click="processRegister" class="cursor-pointer text-teal-500 white-space-nowrap">Signup for Account</a>
            </li>
        </ul>
    </div>
</template>

<script>

export default {

    methods: {
        processRegister() {
            console.log("[HeadingRegister][processRegister] Beginning.");
            window.location.href = "/#/register";
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
